export default "__VITE_ASSET__ayxNESOLd2Imglv3gyk8eg__"